import { useApplyEdition } from '@/pages/Apply/components/use-apply-edition';
import type { ApplyProfilesShow } from '@/types';
import { LogoutLink } from '../components/LogoutLink';
import { ProfileMultiStep } from '../components/ProfileMultiStep';

function firstName(fullName: string): string {
  return fullName.trim().split(/\s+/)[0]?.toLowerCase() || 'leader';
}

// app/(public)/${eventSlug}/apply/profile/page.tsx + leader-profile-form.tsx.
export default function Show({
  ownerFullName,
  storageKey,
  initial,
  linkedinCheckUrl,
  photoStep,
}: ApplyProfilesShow) {
  const { eventSlug } = useApplyEdition();
  return (
    <>
      <LogoutLink />
      <ProfileMultiStep
        ownerName={ownerFullName}
        ownerFirstName={firstName(ownerFullName)}
        initial={initial}
        storageKey={storageKey}
        submitUrl={`/${eventSlug}/apply/profile`}
        submitMethod="patch"
        submitLabel="Guardar perfil"
        cancelHref={`/${eventSlug}/apply/dashboard`}
        linkedinCheckUrl={linkedinCheckUrl}
        photoStep={photoStep}
      />
    </>
  );
}
